app.service('productCardGallery', function(
	html,
	productCardConfig,
	console,
	loading
) {
	const gallery = {
		$self: null,
		$items: [],
		$iframes: [],
		$thumbnails: [],
		thumbnailsCarousel: null,
		countItems: 0,
		activeItem: 0
	};

	const modal = {
		exists: false,
		isOpen: false
	};

	function setElements() {
		gallery.$thumbnailsCarousel = $('.modal-gallery-thumbnails', gallery.$self);
		gallery.$thumbnails = $('.gallery-thumbnail', gallery.$thumbnailsCarousel);
		gallery.$items = $('.gallery-item', gallery.$self);
		gallery.$iframes = $('iframe', gallery.$self);
		gallery.countItems = gallery.$items.length;
	}

	function setEvents() {
		gallery.$self.on('click', '.js-gallery-thumbnail', function() {
			stopVideos();
			reloadVideos();
			const position = $(this).data('position');
			setActiveItem(position);
		});
		gallery.$self.on('click', '.js-modal-close', function() {
			toggleModal();
		});
		gallery.$self.find('.modal-gallery-items').swipe({
			swipe: function(event, direction) {
				const nextItem = getNextActiveItem(direction);
				setActiveItem(nextItem);
				scrollActiveThumbnailIntoView();
			},
			excludedElements: '.orbitvu-viewer'
		});
		gallery.$self.on(
			'webkitAnimationEnd oanimationend msAnimationEnd animationend',
			function() {
				scrollActiveThumbnailIntoView();
			}
		);
	}

	function reloadVideos() {
		gallery.$iframes.each(function() {
			$(this).attr('src', $(this).data('src'));
		});
	}

	function stopVideos() {
		gallery.$iframes.each(function() {
			const source = $(this).attr('src');
			$(this).attr('src', '');
			$(this).data('src', source);
		});
	}

	function toggleModal() {
		if (modal.isOpen) {
			html.remove('modal-gallery');
			html.add('modal-gallery-close');
			stopVideos();
		} else {
			html.remove('modal-gallery-close');
			html.add('modal-gallery');
		}
		modal.isOpen = !modal.isOpen;
	}

	function loadModal() {
		const { id: productId } = productCardConfig.getData();

		return $.ajax({
			url: '/product-multimedia.ltr',
			data: { productId }
		});
	}

	function getNextActiveItem(direction) {
		switch (direction) {
			case 'left':
				return gallery.activeItem + 1;

			case 'right':
				return gallery.activeItem - 1;

			default:
				return gallery.activeItem;
		}
	}

	function setActiveThumbnail() {
		const $activeThumbnail = gallery.$thumbnails.eq(gallery.activeItem);

		$activeThumbnail
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	}

	function scrollActiveThumbnailIntoView() {
		const $activeThumbnail = gallery.$thumbnails.eq(gallery.activeItem);
		const offset = $activeThumbnail.offset().left - 10;
		const scrollLeft = gallery.$thumbnailsCarousel.scrollLeft() + offset;

		gallery.$thumbnailsCarousel.animate({ scrollLeft });
	}

	function setActiveItem(nextItem) {
		if (nextItem > -1 && nextItem < gallery.countItems) {
			gallery.$self.removeClass('shift-' + gallery.activeItem);
			gallery.$self.addClass('shift-' + nextItem);
			gallery.activeItem = nextItem;
		}
		setActiveThumbnail();
	}

	function findSelectedItemPosition(selectedItem, type = 'photo') {
		return gallery.$items
			.filter((index, item) => item.dataset.type === type)
			.eq(type === 'photo' ? selectedItem : 0)
			.data('position');
	}

	function open(selectedItem, type) {
		if (modal.exists) {
			toggleModal();
			const position = findSelectedItemPosition(selectedItem, type);
			setActiveItem(position);
			reloadVideos();
		} else {
			loadModal().then(html => {
				gallery.$self.html(html);
				toggleModal();
				setElements();
				setEvents();
				const position = findSelectedItemPosition(selectedItem, type);
				setActiveItem(position);
				modal.exists = true;
			});
		}
	}

	function init() {
		gallery.$self = $('#modal-gallery-box');
	}
	return { init, open };
});
